import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getUnits = async () => {
    const respuesta = await PrivateInterceptor('Global/Units', 'GET');
    return respuesta;
}